import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import type { Lang, Localized } from '../types';
interface LanguageValue {
  lang: Lang;
  setLang: (lang: Lang) => void;
  toggle: () => void;
  t: (value: Localized) => string;
}
const LanguageContext = createContext<LanguageValue | null>(null);
interface LanguageProviderProps {
  initialLang?: Lang;
  children: React.ReactNode;
}
export function LanguageProvider({
  initialLang = 'en',
  children
}: LanguageProviderProps) {
  const [lang, setLang] = useState<Lang>(initialLang);
  const toggle = useCallback(() => {
    setLang(current => current === 'en' ? 'es' : 'en');
  }, []);
  const value = useMemo<LanguageValue>(() => ({
    lang,
    setLang,
    toggle,
    t: (localized: Localized) => localized[lang]
  }), [lang, toggle]);
  return <LanguageContext.Provider value={value} data-id="element-388" data-mp="2ellu709cn105">{children}</LanguageContext.Provider>;
}
export function useLanguage(): LanguageValue {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used inside a LanguageProvider');
  }
  return context;
}